import * as React from 'react';
import Link from '@mui/material/Link';


const venueLink = "https://www.mos.org/events/private-events";

type VenueLinkProps = {
  linkText?: string,
  underline?: "hover" | "always" | "none"
};

const defaultProps: VenueLinkProps = {
  linkText: "Washburn Pavilion - Museum of Science",
  underline: "hover"
};

export default function VenueLink(linkProps: VenueLinkProps = defaultProps) {
  return (
          <Link href={venueLink} 
            underline={linkProps.underline ? linkProps.underline : defaultProps.underline}
            >
            {linkProps.linkText ? linkProps.linkText : defaultProps.linkText}
          </Link>
  );
}